module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-nautilus.502dac97876417c33fa1fd816dbe1be7.png";